/*
 * SOLVEY · gratis crème bij abonnement
 * --------------------------------------------------------------------------
 * Owner-wens 2026-07-06: wie een abonnement afsluit krijgt 1× gratis crème in
 * de winkelmand. Firmhouse biedt hier geen cadeau-optie voor, dus doen we het
 * met code. De abo-checkout loopt via de STANDAARD Shopify-checkout (Firmhouse-
 * plannen zijn native Shopify selling plans → de abo-regel draagt een
 * `selling_plan_allocation`), dus een €0-regel in de cart reist correct mee.
 *
 * MECHANIEK
 *   Een verborgen product/variant met prijs €0,00 (in de admin aangemaakt,
 *   variant-ID via Theme Editor) wordt automatisch als éénmalige regel in de
 *   mand gelegd zodra er een abonnement in de mand zit, en er weer uit gehaald
 *   zodra het abonnement verdwijnt. Éénmalig = herhaalt niet (alleen de abo-
 *   regel recurt via Firmhouse), dus "1× gratis bij het nemen van een abo".
 *
 * WAAROM fetch-interceptie i.p.v. de private event-bus:
 *   Het thema ververst de quick-cart drawer via een MODULE-PRIVATE emitter
 *   (theme.js `r$1('quick-cart:updated')`) die van buitenaf onbereikbaar is
 *   (zie ad-autocart). Maar het thema roept ná elke cart-mutatie eerst zijn
 *   eigen `get()` (/cart.js) aan om de drawer opnieuw te renderen. Door onze
 *   verzoening te DRAAIEN vóórdat we de mutatie-response teruggeven aan het
 *   thema, zit de gratis crème al in de mand wanneer het thema `get()` doet →
 *   de drawer toont meteen het juiste beeld, zonder reload en zonder de bus.
 *
 * Alle eigen cart-calls gaan via de ORIGINELE fetch (niet de wrapper), dus er
 * ontstaat geen recursie. `reconcile()` is idempotent (doet alleen iets als de
 * staat afwijkt), dus het convergeert en stopt vanzelf.
 */
(function () {
  'use strict';

  var CFG = window.SOLVEY_SUB_GIFT || {};
  if (!CFG.enabled) return;
  var GIFT = parseInt(CFG.variantId, 10);
  if (!GIFT) return;

  // Cart-mutatie-endpoints (Weglot /nl/-prefix negeren we door substring-match).
  var MUT = /\/cart\/(add|change|update|clear)(\.js)?([?#]|$)/;

  var origFetch = window.fetch.bind(window);
  var reconciling = false;

  function cartJson() {
    return origFetch('/cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'include'
    }).then(function (r) { return r.json(); });
  }

  // Abo aanwezig = een regel met een selling_plan_allocation die niet de
  // gratis crème zelf is (de crème is éénmalig, dus dat kan sowieso niet).
  function hasSubscription(cart) {
    return (cart.items || []).some(function (i) {
      return i.selling_plan_allocation && i.variant_id !== GIFT;
    });
  }

  function findGift(cart) {
    return (cart.items || []).filter(function (i) {
      return i.variant_id === GIFT;
    })[0] || null;
  }

  function addGift() {
    return origFetch('/cart/add.js', {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: GIFT, quantity: 1, properties: { _solvey_gift: '1' } }]
      })
    });
  }

  // change.js accepteert een line-key of variant-ID als `id`.
  function changeGift(qty, line) {
    return origFetch('/cart/change.js', {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: line || String(GIFT), quantity: qty })
    });
  }

  // Breng de gratis-crème-regel in lijn met de abo-status in de mand.
  function reconcile() {
    if (reconciling) return Promise.resolve();
    reconciling = true;
    return cartJson().then(function (cart) {
      var sub = hasSubscription(cart);
      var gift = findGift(cart);
      if (sub && !gift) return addGift();
      if (sub && gift && gift.quantity > 1) return changeGift(1, gift.key);
      if (!sub && gift) return changeGift(0, gift.key);
      return null;
    }).catch(function () { /* stil falen: nooit de checkout blokkeren */ })
      .then(function () { reconciling = false; });
  }

  // --- fetch-interceptie: verzoen ná de mutatie, vóór de theme-response ------
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var isMut = MUT.test(url);
    var p = origFetch(input, init);
    if (!isMut || reconciling) return p;
    return p.then(function (res) {
      return reconcile().then(function () { return res; });
    });
  };

  // --- vangnet: publieke DOM-events (dekt XHR-adds e.d.) ---------------------
  // Deze vuren ná de drawer-refresh, dus puur voor cart-correctheid (checkout);
  // de drawer is dan al vers via de fetch-interceptie hierboven.
  ['cart:updated', 'cart:item-added'].forEach(function (ev) {
    document.addEventListener(ev, function () { reconcile(); });
  });

  // --- initiële staat (bv. achtergebleven crème zonder abo) ------------------
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reconcile);
  } else {
    reconcile();
  }
})();
